export default function LogoCloud() {
  return (
    <div>
      <p className='text-brand-accent dark:text-brand-dark-text-secondary mt-24 text-center text-xs font-bold tracking-[0.3em] uppercase'>
        Build with
      </p>
      <div className='my-12 grid grid-cols-1 place-items-center space-y-4 sm:mt-8 sm:grid sm:grid-cols-5 sm:gap-6 sm:space-y-0 md:mx-auto md:max-w-2xl'>
        <div className='flex h-12 items-center justify-start'>
          <a
            href='https://nextjs.org'
            aria-label='Next.js Link'>
            <img
              src='/nextjs.svg'
              alt='Next.js Logo'
              className='logo-img logo-white h-6 opacity-60 transition-all hover:opacity-100 sm:h-12'
            />
          </a>
        </div>
        <div className='flex h-12 items-center justify-start'>
          <a
            href='https://vercel.com'
            aria-label='Vercel.com Link'>
            <img
              src='/vercel.svg'
              alt='Vercel.com Logo'
              className='logo-img logo-white h-6 opacity-60 transition-all hover:opacity-100'
            />
          </a>
        </div>
        <div className='flex h-12 items-center justify-start'>
          <a
            href='https://stripe.com'
            aria-label='stripe.com Link'>
            <img
              src='/stripe.svg'
              alt='stripe.com Logo'
              className='logo-img logo-white h-12 opacity-60 transition-all hover:opacity-100'
            />
          </a>
        </div>
        <div className='flex h-12 items-center justify-start'>
          <a
            href='https://supabase.io'
            aria-label='supabase.io Link'>
            <img
              src='/supabase.svg'
              alt='supabase.io Logo'
              className='logo-img logo-white h-10 opacity-60 transition-all hover:opacity-100'
            />
          </a>
        </div>
        <div className='flex h-12 items-center justify-start'>
          <a
            href='https://github.com'
            aria-label='github.com Link'>
            <img
              src='/github.svg'
              alt='github.com Logo'
              className='logo-img logo-white h-8 opacity-60 transition-all hover:opacity-100'
            />
          </a>
        </div>
      </div>
    </div>
  );
}
